"use strict";

exports.__esModule = true;
exports.default = void 0;
var _ListCache = _interopRequireDefault(require("./_ListCache.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache.default();
  this.size = 0;
}
var _default = exports.default = stackClear;